// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3g7SW","actionsCol":"EnrolledClinics_actionsCol__JMW35"};